// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radEpzytbN7ukI {
  color: var(--ds-text-subtle, #44546f);
  font-size: 14px;
  font-style: italic;
  text-align: center;
}
.v4oEtEQIEw7m0U {
  color: var(--ds-text-subtle, #44546f);
  font-style: italic;
  text-align: center;
}
.v4oEtEQIEw7m0U hr {
  margin-top: 0;
}
.ZIQoYe1SNEHYfw {
  display: none;
}
.ZIQoYe1SNEHYfw.e384SQ1WUYoxFu {
  display: block;
}
.rIi0haOQLn0A3n h1 {
  display: flex;
  align-items: center;
  font-size: 18px;
  line-height: 30px;
}
.rIi0haOQLn0A3n h1 span {
  margin-left: 5px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"requestMembersEmptyStateText": `radEpzytbN7ukI`,
	"guestEmptyState": `v4oEtEQIEw7m0U`,
	"section": `ZIQoYe1SNEHYfw`,
	"active": `e384SQ1WUYoxFu`,
	"container": `rIi0haOQLn0A3n`
};
export default ___CSS_LOADER_EXPORT___;
